/**
 * DG Engine API 클라이언트
 * /api/engine/dg/* 엔드포인트 호출
 */

import { auth } from '../config/firebaseConfig';

const API_BASE = '/api/engine/dg';

async function getAuthHeader() {
  try {
    const user = auth.currentUser;
    if (!user) return {};
    const token = await user.getIdToken();
    return { Authorization: `Bearer ${token}` };
  } catch {
    return {};
  }
}

async function apiFetch(path, options = {}) {
  try {
    const headers = await getAuthHeader();
    const res = await fetch(`${API_BASE}${path}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...headers,
        ...options.headers,
      },
    });
    return res.json();
  } catch (err) {
    console.warn('[DGEngineService]', err.message);
    return null;
  }
}

const dgEngineService = {
  /**
   * DG Engine 헬스체크
   */
  health: () => apiFetch('/health'),

  /**
   * 사용자 상태 벡터 조회
   */
  getState: (userId) => apiFetch(`/state/${userId}`),

  /**
   * 사용자 장기 프로파일 조회
   */
  getProfile: (userId) => apiFetch(`/profile/${userId}`),

  /**
   * 단일 후보 수락 확률 예측
   */
  predict: (userId, candidateId, features, context = {}) =>
    apiFetch('/predict', {
      method: 'POST',
      body: JSON.stringify({ userId, candidateId, features, context }),
    }),

  /**
   * 연쇄 재배치 계획
   */
  cascade: (triggerEvent, currentAssignments, availableCandidates, constraints = {}) =>
    apiFetch('/cascade', {
      method: 'POST',
      body: JSON.stringify({ triggerEvent, currentAssignments, availableCandidates, constraints }),
    }),

  /**
   * GPS 위치 업데이트
   */
  updateLocation: (userId, lat, lng, accuracy) =>
    apiFetch('/location/update', {
      method: 'POST',
      body: JSON.stringify({ userId, lat, lng, accuracy }),
    }),

  /**
   * 참여자 중간지점 계산
   */
  getMidpoint: (participants, options = {}) =>
    apiFetch('/location/midpoint', {
      method: 'POST',
      body: JSON.stringify({ participants, options }),
    }),
};

export default dgEngineService;
